/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Running, 1 = Completed, 2 = Aborted
 */
export enum WizardRunStatus {
    Running = 0,
    Completed = 1,
    Aborted = 2
}

